module.exports = __webpack_public_path__ + "static/media/DSCF9890.806cfdec.jpg";